import Navbar from '../Components/Navbar/Navbar'
import IndicadorCampoWeb from '../Components/Home/IndicadoresCampoWeb'

const IndicadoresCampoWeb = () => {
    return (
        <section>
            <Navbar />
           <IndicadorCampoWeb/>
        </section>
    )
}

export default IndicadoresCampoWeb
